import { SEARCH_ALL_PARAMS_APP_STATE_SLICE_KEY, SEARCH_ALL_PARAMS_STATE_KEYS } from '../state/constants';
import { AppStateService } from 'NewAngular/services/app-state.service';
import * as i0 from "@angular/core";
import * as i1 from "NewAngular/services/app-state.service";
export class SearchAllStateService {
    constructor(appStateService) {
        this.appStateService = appStateService;
    }
    initAppState() {
        this.appStateService.setStateSlice(SEARCH_ALL_PARAMS_APP_STATE_SLICE_KEY);
        this.appStateService.setUrlParamKeys(SEARCH_ALL_PARAMS_STATE_KEYS);
        this.appStateService.start();
    }
}
SearchAllStateService.ɵfac = function SearchAllStateService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || SearchAllStateService)(i0.ɵɵinject(i1.AppStateService)); };
SearchAllStateService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: SearchAllStateService, factory: SearchAllStateService.ɵfac, providedIn: 'root' });
